import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { BuilderState } from './types';
import { RootState } from '../types';

export const state: BuilderState = {
  templates: [],
  pages: [],
  page: null,
  progamId: null,
  pagePreviewModal: false,
  previewType: 'mobile',
};

export const builder: Module<BuilderState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
